export default __webpack_public_path__ + "static/media/delete.f062e351.svg";